import ApplicationModel, { attr } from '../ApplicationModel';
import { type AiRequestAttributes } from './generated/AiRequestAttributes';
import { model } from '../modelBuilder';

interface AiRequest extends AiRequestAttributes {}

@model
class AiRequest extends ApplicationModel {
  // Start auto-generated
  static typename: 'AiRequest' = 'AiRequest';
  get typename(): 'AiRequest' {
    return 'AiRequest';
  }

  static internalTypename: 'AiRequest' = 'AiRequest';
  get internalTypename(): 'AiRequest' {
    return 'AiRequest';
  }

  static filterType = 'AiRequestFilters!';
  static filters = {
    kind: 'AiRequestKindEnum',
    unique: 'Boolean',
    hasInputs: 'Boolean',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    inputs: attr({ readable: true, json: true }),
    kind: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
  };
  // End auto-generated
}

export default AiRequest;
